let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3RPI6")).then(() => parcelRequire('h8HrR'));